import React from 'react';
import {TextAreaStructure} from './TextAreaStructure';

export const RawTextArea = ({name, rows, disabled, label, value, code, ...rest}) => (
    <TextAreaStructure label={label} disabled={disabled} code={code}>
        <textarea rows={rows} id={name} name={name} value={value} {...rest} disabled={disabled} />
    </TextAreaStructure>
);
